import { Component } from '@angular/core';
import { BaseDetailPageComponent } from '../../../../components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from '../../../../models/base-detail-page.config';
import { ItemsService } from '../../../../services/api/general-settings/items.service';
import { RouteService } from '../../../../services/route.service';

@Component({
  selector: 'app-items-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './items-detail-page.component.html',
  styleUrl: './items-detail-page.component.scss'
})
export class ItemsDetailPageComponent {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail: boolean

  item?: any;

  constructor(
    private itemsService: ItemsService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Items',
      cardTitle: 'Item Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Item',
        onClick: () => {
          this.routeService.itemsUpdate(this.item?.itemId)
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'Jurisdiction',
            label: 'Jurisdiction',
            value: (item: any) => {
              return item.jurisdiction.name;
            }
          },
          {
            attribute: 'Product',
            label: 'Product',
            value: (item: any) => {
              return item.itemProduct.name;
            }
          },
          {
            attribute: 'Type',
            label: 'Type',
            value: (item: any) => {
              return item.itemType.name;
            }
          },
          {
            attribute: 'Price',
            label: 'Price',
            value: (item: any) => {
              return item.price;
            }
          },
          {
            attribute: 'Max Discount',
            label: 'Max Discount',
            value: (item: any) => {
              return item.maxDiscountPercent;
            }
          },
          {
            attribute: 'Operating Cost',
            label: 'Operating Cost',
            value: (item: any) => {
              return item.operatingCost;
            }
          },
          {
            attribute: 'Introducer',
            label: 'Introducer',
            value: (item: any) => {
              return item.introducerPercent;
            }
          },
          {
            attribute: 'Margin',
            label: 'Margin',
            value: (item: any) => {              
              return item.price - item.operatingCost;
            }
          },
        ]
      },
      apiDetailService: (itemId: number) => this.itemsService.detail(itemId),
      routeParamName: 'itemId',
      responseModelName: 'item'
    };
  }

  onLoadedDetail(data: any) {
    this.item = data;
  }
}
